import React, { Component } from "react";
import { Form, Button, Input, Checkbox, Row, Col, Spin, Select, Space } from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import DriverGroupStore from "../store/DriverGroupStore";
import withRouter from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import DriversStore from "../store/DriversStore";

class DriverGroupAdd extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showAsset: false,
            selectedChecked: false,
            selectedValues: [],
            drgId: "",
            companyId: "",
            loadingSpin: false,
            driverId: '',
        };
        this.groupStore = new DriverGroupStore();
        this.companyStore = new CompanyStore();
        this.driverStore = new DriversStore();

    }
    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ isadmin: this.props.getUserData().isadmin });

            await this.driverStore.toGetDriverName(
                this.props.getUserData().userCompanyId
            );

            await this.setState({ update: 1 });
        }
        const drgId = this.props.drgId;
        if (drgId) {
            await this.filldata(drgId);
            await this.setState({ drgId: drgId });
        }
    }

    filldata = async (drgId) => {
        console.log("object", this.props)
        await this.setState({ loadingSpin: true });
        const getDriverGroup = await this.groupStore.getDriverGroupData(
            drgId,
            this.props.companyId
        );

        const singleData = await this.companyStore.getCompanyDataById(
            this.props.companyId
        );


        await this.setState({
            companyId: getDriverGroup.companyId,
            drgId: getDriverGroup.drgId,
        });

        if (getDriverGroup.drivers.length === this.driverStore.getDriverName.length) {
            this.setState({ selectedChecked: true });
        }
        await this.formRef.current.setFieldsValue({
            drgId: getDriverGroup.drgId,
            companyId: singleData,
            groupName: getDriverGroup.groupName,
            driverId: getDriverGroup.drivers
                ? getDriverGroup.drivers.map((item) => Number(item.driverId))
                : []
        });
        await this.setState({ loadingSpin: false });
    };

    onDeviceDetailsSubmit = async (values) => {
        this.setState({ loading: true });
        console.log(values)
        const data = {
            ...values,
            companyId: this.state.companyId,
            drgId: this.state.drgId,
        };
        console.log(data);
        const resp = await this.groupStore.addData(data);
        await this.props.response(resp);

        this.setState({ loading: false });
    };

    async handleChange(comp) {
        await this.setState({ companyId: comp.value });
        if (!this.props.driverGroupId) {
            this.context.viewStateStore.setDriverGroupStates({
                companyId: comp.value,
            });
        }
        await this.driverStore.toGetDriverName(comp.value);
        this.setState({ update: 1 });
        await this.setState({ companyId: comp.value });

        const data = await this.groupStore.getAssetData(this.state.companyId);
        console.log("data", data);
    }

    async handleSearch() {
        await this.groupStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }

    handleSelectAllChange = async (e) => {
        this.setState({ selectedChecked: e.target.checked });

        if (e.target.checked) {
            const allValues = this.groupStore?.driverList.map(
                (option) => option.vehicleId
            );
            this.formRef.current.setFieldsValue({ vehicle: allValues.vehicleNo });

            await this.setState({ selectedValues: allValues });
        } else {
            await this.setState({ selectedChecked: e.target.checked });
            await this.setState({ selectedValues: [] });
        }
    };
    closeModal = () => {
        this.props.closeModal();
    };

    render() {
        return (
            <div style={{ padding: 0, height: "100%" }}>
                <div style={{ paddingBottom: "10px", height: "100%" }}>
                    <Spin
                        spinning={this.state.loadingSpin}
                        fullscreen
                        wrapperClassName="spinClass"
                    >
                        <Form
                            style={{ maxWidth: "100%" }}
                            layout="vertical"
                            ref={this.formRef}
                            onFinish={this.onDeviceDetailsSubmit}
                            name="nest-message"
                            className="formClass"
                        >
                            <Row className="overflowFormInputs">
                                <Col span={24} className="formColumnClass">
                                    {/* css class */}
                                    {(this.props.getUserData().isadmin === -1 ||
                                        this.props.getUserData().isadmin === 3) && (
                                            <Form.Item
                                                className="uploadCompany"
                                                name="companyId"
                                                label={
                                                    <span>
                                                        {this.context.translate("_ACCOUNT_")}{" "}
                                                        <span style={{ color: "red" }}>*</span>
                                                    </span>
                                                }
                                                required={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `${this.context.translate(
                                                            "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                    },
                                                ]}
                                            >
                                                <CompanyAutocomplete
                                                    onChange={(value) => this.handleChange(value)}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        )}

                                    <Form.Item
                                        name="groupName"
                                        className="uploadCompany"
                                        label={
                                            <span>
                                                {this.context.translate("_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_")}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_FLEET_GROUP_GROUPDETAIL_DEVICEGROUP_"
                                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item label=" " className="uploadCompany">
                                        <Checkbox
                                            checked={this.state.selectedChecked}

                                            onChange={(e) => {
                                                const checked = e.target.checked;

                                                if (checked) {
                                                    const allDrivers = (this.driverStore?.getDriverName || []).map(
                                                        (d) => d.driverId
                                                    );
                                                    this.formRef.current?.setFieldsValue({
                                                        driverId: allDrivers,
                                                    });

                                                    this.setState({
                                                        selectedDrivers: allDrivers,
                                                        selectedChecked: true,
                                                    });
                                                } else {
                                                    this.formRef.current?.setFieldsValue({
                                                        driverId: [],
                                                    });

                                                    this.setState({
                                                        selectedDrivers: [],
                                                        selectedChecked: false,
                                                    });
                                                }
                                            }}
                                        >
                                            Select All Drivers
                                        </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                        // style={{ width: "100%", height: "80px" }}
                                        className="search-field"
                                        value={this.state.driverId}
                                        name="driverId"
                                        label={
                                            <span>
                                                {this.context.translate("_DRIVER_NAME_")}{" "}
                                                <span style={{ color: "red" }}>*</span>
                                            </span>
                                        }
                                        required={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: `${this.context.translate(
                                                    "_DRIVER_NAME_"
                                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                            },
                                        ]}
                                    >
                                        <Select
                                            mode="multiple"
                                            maxTagCount="responsive"
                                            placeholder={this.context.translate("_SELECT_DRIVER_")}
                                            showSearch
                                            fieldNames={{ value: "driverId", label: "name" }}
                                            optionFilterProp="children"
                                            options={this.driverStore?.getDriverName}
                                            filterOption={(input, option) => {
                                                // console.log(input, option);
                                                if (!option?.name) return false;

                                                const label = option.name
                                                    .toString()
                                                    .toLowerCase()
                                                    .replace(/\s+/g, "");

                                                const search = input
                                                    .toLowerCase()
                                                    .replace(/\s+/g, "");

                                                return label.includes(search);
                                            }}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <div className="formFooter">
                                <Space>
                                    <Button
                                        className="formsCancelButton"
                                        onClick={() => this.closeModal()}
                                    >
                                        {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
                                    </Button>
                                    <Button
                                        style={{ marginInlineStart: "0px" }}
                                        loading={this.state.loading}
                                        htmlType="submit"
                                        className="formsSaveButton"
                                    >
                                        {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                    </Button>
                                </Space>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        );
    }
}

DriverGroupAdd.contextType = StoreContext;
export default observer(withRouter(DriverGroupAdd));
